import {useEffect, useState} from "react";
import {Spin, Radio} from "antd";
import {t} from "i18next";
import ApiService from "../../../core/service/api-service";
import Hl7SegmentViewer from "./Hl7SegmentViewer";
import Hl7ReportContent from "./Hl7ReportContent";

// Bir kayıt için tek modal: istek ve (varsa) rapor mesajını gösterir.
// Üstte İstek / Rapor / Rapor İçeriği geçişi SEKME değil BUTON GRUBU'dur.
export default function Hl7PreviewModal({requestMessageId, reportMessageId, defaultTab = 'request'}) {
    const [requestRaw, setRequestRaw] = useState(null);
    const [reportRaw, setReportRaw] = useState(null);
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState(defaultTab === 'report' ? 'content' : 'request');

    useEffect(() => {
        let alive = true;
        (async () => {
            setLoading(true);
            const [reqRes, repRes] = await Promise.all([
                requestMessageId ? ApiService.HL7Service.GetHL7Message(requestMessageId) : Promise.resolve(null),
                reportMessageId ? ApiService.HL7Service.GetHL7Message(reportMessageId) : Promise.resolve(null),
            ]);
            if (!alive) return;
            if (reqRes?.success) setRequestRaw(reqRes.data);
            if (repRes?.success) setReportRaw(repRes.data);
            setLoading(false);
        })();
        return () => { alive = false; };
    }, [requestMessageId, reportMessageId]);

    if (loading) {
        return <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>;
    }

    return (
        <div>
            <Radio.Group
                value={view}
                onChange={e => setView(e.target.value)}
                buttonStyle={'solid'}
                style={{ marginBottom: 12 }}
            >
                <Radio.Button value={'request'} disabled={!requestRaw}>{t('Request')}</Radio.Button>
                <Radio.Button value={'report'} disabled={!reportRaw}>{t('Report')}</Radio.Button>
                <Radio.Button value={'content'} disabled={!reportRaw}>{t('Report Content')}</Radio.Button>
            </Radio.Group>

            <div style={{ minHeight: '58vh' }}>
                {view === 'request' && <Hl7SegmentViewer raw={requestRaw} />}
                {view === 'report' && <Hl7SegmentViewer raw={reportRaw} />}
                {view === 'content' && <Hl7ReportContent raw={reportRaw} />}
            </div>
        </div>
    );
}
